<template>
	<div class="component-container">
		<!--bind ComputerAlert to isOpen data and register listener for the alert to be clicked-->
		<ComputerAlert v-bind:isOpen="isOpen" v-on:onClickComputerAlert="isOpen = true"></ComputerAlert>
		<div class="email" v-show="isOpen">
			<div class="vuebar-element" v-bar="{ preventParentScroll: true, useScrollbarPseudo: true}">
				<div class="vuebar-content">
					<div class="email-content">
						<div class="email-header">
							From: Shady Sam<br />
							To: {{getPlayerName}}<br />
							Date: {{formatedDate}}<br />
							Subject: <span v-html="emailSubject"></span>
						</div>
						<div class="divider"></div>
						<div class="email-body">
							<div v-html="emailBody"></div>
						</div>
						<Button class="startBtn" :action="closeEmail">{{email_data.email_close_button}}</Button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Button from '@/components/abstract/Button';
import ComputerAlert from '@/components/abstract/ComputerAlert';
import { mapState } from 'vuex';
import tracking from '@/mixins/tracking';

export default {
	name: 'SpecialEmail',
	mixins: [tracking],
	data() {
		return {
			isOpen: false,
		};
	},
	components: {
		Button,
		ComputerAlert,
	},
	computed: {
		...mapState({ // get data from wordpress Game Config page
			game_config: state => state.config.data.game_config,
		}),
		email_data() {
			return this.$store.getters.getEmailByID(this.$route.params.id);
		},
		getPlayerName() {
			return this.$store.state.playerName;
		},
		formatedDate() {
			return this.$store.state.todaysDate;
		},
		emailBody() {
			let s = this.email_data.email_body_copy;
			s = s.replace("{{Name}}", this.$store.state.playerName);
			s = s.replace("{{Customer}}", this.$store.state.paydayPerson.title);
			s = s.replace("{{PaydayFees}}", this.$store.state.paydayFees);
			return s;
		},
		emailSubject() {
			let s = this.email_data.email_subject;
			s = s.replace("{{Customer}}", this.$route.params.person.title);
			return s;
		},
	},
	methods: {
		closeEmail() {
			this.$store.commit('incrementScene');
		},
	},
	mounted() {
		this.trackPageview(`email-${this.email_data.title}`, `/level-${this.$store.state.level + 1}/request-${this.$store.state.scene + 1}/${this.email_data.title}/email`);
	},
};
</script>

<style lang="scss" scoped>
	// global email styles are in base-classes
</style>



// WEBPACK FOOTER //
// src/components/emails/SpecialEmail.vue